// extracted by mini-css-extract-plugin
export default {"background_card__body":"backgroundCard_background_card__body__p5wWT"};